import AnimatedCursor from 'react-animated-cursor'
import useDeviceDetection from '../hooks/useDeviceDetection'

const CustomCursor = () => {
  const device = useDeviceDetection()

  if (device === 'Mobile' || device === 'Tablet') return null

  return (
    <div>
      <AnimatedCursor
        innerSize={8}
        outerSize={35}
        innerScale={1}
        outerScale={2}
        outerAlpha={0}
        innerStyle={{
          backgroundColor: 'black',
        }}
        outerStyle={{
          border: '3px solid black',
        }}
      />
    </div>
  )
}

export default CustomCursor
